"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootPage = exports.RootPageConfig = void 0;
const mithril_1 = require("../mithril");
const services_1 = require("../services");
const page_1 = require("./page");
exports.RootPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.root,
    path: '/',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
class RootPage extends page_1.IkePage {
    constructor() {
        super(exports.RootPageConfig);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { onupdate: this.redirect, oncreate: this.redirect });
    }
    redirect() {
        // We check if the user is authenticated
        // so we don't have to do double refresh
        if (services_1.Services.User.isAuthenticated) {
            services_1.Services.Route.go(page_1.IkePageName.map);
        }
        else {
            services_1.Services.Route.go(page_1.IkePageName.login);
        }
    }
}
exports.RootPage = RootPage;
//# sourceMappingURL=root.page.js.map